import {StyleSheet} from "@react-pdf/renderer";

export default StyleSheet.create({
    cell: {
        padding: 10,
        justifyContent: "center"
    }
})
